<template>
  <div class="nav-bottom-base">
    <rl-bg class="nav-bg">
      <div class="nav-logo ">
        <img  src="~assets/ripeav.png">
      </div>
      <div class="nav-menu " >
        <a
            v-for="(item,index) in title" :key="index" @click="Onclick(index)" :class=" {Current: CurrentHeadIndex == index}">
          <router-link :to="UrlList[index]">{{item.menuName}}</router-link>
        </a>
      </div>
      <div class="nav-search ">
        <div class="nav-tel">
          <span>全国服务热线</span>
          <span>400-0571-819</span>
        </div>
        <span class="span">中</span>
      </div>
    </rl-bg>
  </div>
</template>

<script>
import RlBg from "@/components/bg";
export default {
  name: "RlHeader",
  components: {RlBg},
  data(){
    return{
      title: {},
      UrlList:['/home','/product','/partner','/service','/join','/about'],
      ShowNavItem:false,
      CurrentHeadIndex:0,
    }
  },
  created() {
    this.$router.push(this.UrlList[this.SIndex])
    this.$axios.get('/api/menu/getMenuTree').then(res=>{
      this.title=res.data.data
    })
  },
  mounted() {
    this.adjust(this.$route.path)
  },
  methods:{
    Onclick(index){
      this.CurrentHeadIndex=index;
    },
    adjust(name){
      if ( name.indexOf('/home') !== -1){
        this.CurrentHeadIndex=0
      }
      if ( name.indexOf('/product') !== -1){
        this.CurrentHeadIndex=1
      }
      if ( name.indexOf('/partner') !== -1){
        this.CurrentHeadIndex=2
      }
      if ( name.indexOf('/service') !== -1){
        this.CurrentHeadIndex=3
      }
      if (name.indexOf('/join') !== -1){
        this.CurrentHeadIndex=4
      }
      if (name.indexOf('/about') !== -1){
        this.CurrentHeadIndex=5
      }
    }
  }
}
</script>

<style lang="less" scoped>
.Current{
  border-bottom: 4px solid #358ED7;
  color: #188ACB;
}

@media screen and (min-width: 1100px){
  .nav-bottom-base{
    height: 80px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
    position: sticky;
    top: 0;
    z-index: 1001;
    background: #FFFFFF;
  }
  .nav-bg{
    display: flex;
    justify-content: space-between;
    .nav-logo{
      img{
        width: auto;
        height: 80px;
      }
    }
    .nav-menu{
      width: 50%;
      display: flex;
      justify-content: space-between;
      a{
        text-decoration: none;
        color: black;
        width: 64px;
        //height: 76px;
        text-align: center;
        display: block;
        height: 80px;
        line-height: 80px;
        font-family: 思源黑体 CN Bold Bold;
      }
    }
    .nav-search{
      .nav-tel{
        width: 120px;
        font-family: 思源黑体 CN Bold Bold;
        font-weight: bold;
        span{
          display: block;
          font-size: 14px;
          &:last-child{
            letter-spacing: 1px;
          }
        }
      }
      display: flex;
      width: 180px;
      justify-content: space-between;
      align-items: center;
      .span{
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 1px solid #333333;
        padding: 4px;
        line-height: 22px;
        font-size: 12px;
        text-align: center;
      }
    }
  }
}
@media screen and (max-width: 1100px){
  .nav-bottom-base{
    height: 60px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
    position: sticky;
    top: 0;
    z-index: 1001;
    background: #FFFFFF;
  }
  .nav-bg{
    display: flex;
    justify-content: space-between;
    .nav-logo{
      img{
        width: auto;
        height: 60px;
      }
    }
    .nav-menu{
      display: flex;
      justify-content: space-between;
      a{
        text-decoration: none;
        color: black;
        width: 64px;
        font-size: 14px;
        text-align: center;
        display: block;
        height: 60px;
        line-height: 60px;
        font-family: 思源黑体 CN Bold Bold;
      }
    }
    .nav-search{
      font-size: 14px;
      .nav-tel{
        width: 120px;
        font-family: 思源黑体 CN Bold Bold;
        font-weight: bold;
        span{
          display: block;
          font-size: 14px;
          &:last-child{
            letter-spacing: 1px;
          }
        }
      }
      display: flex;
      width: 140px;
      justify-content: space-between;
      align-items: center;
      .span{
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 1px solid #333333;
        padding: 4px;
        line-height: 22px;
        font-size: 12px;
        text-align: center;
      }
    }
  }
}
</style>